<template>
  <nav class="bottom-navbar">
    <div class="cov-nb">
      <router-link to="/" class="nav-button">
        <Home class="nav-icon" />
        <span class="nav-label">Home</span>
      </router-link>
    </div>

    <div class="cov-nb">
      <router-link to="/dokter" class="nav-button">
        <Calendar class="nav-icon" />
        <span class="nav-label">Jadwal</span>
      </router-link>
    </div>

    <div class="cov-nb-center">
      <a :href="whatsappLink" target="_blank" class="nav-button center-button">
        <Phone class="nav-icon" />
      </a>
    </div>

    <div class="cov-nb">
      <router-link to="/promo" class="nav-button">
        <Tag class="nav-icon" />
        <span class="nav-label">Promo</span>
      </router-link>
    </div>

    <div class="cov-nb">
      <a :href="linkTree" class="nav-button" target="_blank">
        <Link class="nav-icon" />
        <span class="nav-label">Tautan</span>
      </a>
    </div>
  </nav>
</template>

<script setup>
import { Home, Calendar, Tag, Phone, Link } from 'lucide-vue-next';

const whatsappLink = `https://api.whatsapp.com/send?phone=6287843882204&text=Hallo%20Melinda%20Hospital`;
const linkTree = `https://www.linktr.ee/melindahealthcare`;
</script>

<style scoped>
.bottom-navbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: var(--white);
  color: var(--grey);
  border-top: 1px solid #ddd;
  display: none;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 -1px 5px rgba(0,0,0,0.1);
  z-index: 1000;
  font-weight: 700;
  padding: 0 4px;
}

.cov-nb {
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cov-nb-center {
  position: relative;
  top: -20px;
  width: 20%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-button {
  background: none;
  border: none;
  outline: none;
  text-align: center;
  color: #333;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
}

.center-button {
  width: 60px;
  height: 60px;
  background-color: var(--primary);
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  justify-content: center;
  align-items: center;
  color: var(--white);
  font-size: 16px;
}

.router-link-exact-active {
  color: var(--primary);
}

.nav-icon {
  width: 22px;
  height: 22px;
  margin-bottom: 2px;
}

.router-link-exact-active .nav-icon {
  stroke: var(--primary);
}

@media only screen and (min-width: 751px){
  .bottom-navbar {
    display: none;
  }
}
</style>
